import { RouteProps } from '../../routes/AppRouter'
import { Title } from '../../components/common/Title'
import { Improvements } from '../../features/improvements'
import { useTranslation } from 'react-i18next'
import { TITLE_IMPROVEMENTS } from '../../routes/title-constants'

export const ImprovementsPg = (props: RouteProps) => {
    const { t } = useTranslation()

    return (
        <>
            <Title color={props.color} title={t(TITLE_IMPROVEMENTS)} />
            <Improvements />
        </>
    )
}